import { createSelector } from 'reselect';
import { PAGE_INDICES } from '../../actions/travelUg/types';
import { getTravelUgInsurance } from './index';

const getRouting = createSelector(getTravelUgInsurance, (state) => state.routing);
export const getActivePageIndex = createSelector(getRouting, (routing) => routing.activePageIndex);
export const getDoTravelInsuranceNavigation = createSelector(getRouting, (routing) => routing.doNavigation);
export const getDoExitMotorInsuranceNavigation = createSelector(getRouting, (routing) => routing.doExitNavigation);

export const getLandingPage = createSelector(getRouting, (routing) => routing.landingPage);

export const getIsDropoffPage = createSelector(
    getRouting,
    (routing) => routing.activePageIndex === PAGE_INDICES.ABOUT_YOU
);

const makeGetIsPage = (pageIndex) => createSelector(getRouting, (routing) => routing.activePageIndex === pageIndex);
export const getIsQuotePage = makeGetIsPage(PAGE_INDICES.QUOTE);
export const getIsTravelDetailsPage = makeGetIsPage(PAGE_INDICES.TRAVEL_DETAILS);
export const getIsNextOfKinPage = makeGetIsPage(PAGE_INDICES.NEXT_OF_KIN);
export const getIsPaymentPage = makeGetIsPage(PAGE_INDICES.PAYMENT);

export const getProgressBarIndex = createSelector(
    getIsQuotePage,
    getIsTravelDetailsPage,
    getIsNextOfKinPage,
    getIsPaymentPage,
    (isQuotePage, isTravelDetailsPage, isNextOfKinPage, isPaymentPage) => {
        if (isQuotePage) return 0;
        if (isTravelDetailsPage) return 1;
        if (isNextOfKinPage) return 2;
        if (isPaymentPage) return 3;
    }
);
